import { Grid, Typography } from "@mui/material"
import styles from "../recipeCreation/recipeSteps/editIngredient.module.css";
import { resizeImageIfCloudinary } from "../../utils/images/cloudinaryUtils";

const IngredientCard = ({ ingredientImage, ingredientName }: { ingredientImage: string, ingredientName: string }) => {
    const optimisedImage = resizeImageIfCloudinary(ingredientImage, 180, 180, 180, 180, true);
    return (
        <Grid className={styles.ingredientCardContainer}>
            <img src={optimisedImage} className={styles.ingImage} />
            <Typography>{ingredientName}</Typography>
        </Grid>
    )
}
export default IngredientCard;